export default __webpack_public_path__ + "static/media/icon_arrow_right_small_round.38374d94.svg";